import type { DashboardLabTestStateConstant } from '@pbt/pbt-ui-components'

import type { LabTestDashboardItem } from '~/types'

export const getLabTestComplexId = (
  dashboardLabTestStateConstant: DashboardLabTestStateConstant,
) =>
  `${dashboardLabTestStateConstant?.labTestStateId || ''}|${
    dashboardLabTestStateConstant?.orderStateId || ''
  }`

export const getLabTestSimpleId = (complexId: string) => complexId.split('|')

export const getLabTestIdentifier = ({
  order,
  vendorId,
  soapId,
  invoiceId,
  patient: patientId,
  vet,
}: LabTestDashboardItem) =>
  order?.id
    ? `V:${vendorId}-O:${order.id}`
    : soapId
      ? `V:${vendorId}-S:${soapId}`
      : `V:${vendorId}-I:${invoiceId}-P:${patientId}${
          vet?.id ? `-AV:${vet.id}` : ''
        }`

export const getLabTestIdentifierFromPartial = ({
  orderId,
  vendorId,
  soapId,
  invoiceId,
  patientId,
  vetId,
}: {
  invoiceId: string | null
  orderId: string | null
  patientId: string | null
  soapId: string | null
  vendorId: string | null
  vetId: string | null
}) =>
  orderId
    ? `V:${vendorId}-O:${orderId}`
    : soapId
      ? `V:${vendorId}-S:${soapId}`
      : `V:${vendorId}-I:${invoiceId}-P:${patientId}${
          vetId ? `-AV:${vetId}` : ''
        }`
